import { Editor } from "@tiptap/react";

import { GUIDED_HIGHLIGHTING_ACTIVITY_PANEL } from "@/view/GuidedHighlightingContainer/utils/utils";
import { getDynamicData } from "@/view/TiptapArticleBody/extensions/DataProvider";
import AnnotationsTextSelectionMenu from "./AnnotationsTextSelectionMenu";
import GuidedHighlightingTextSelectionMenu from "./GuidedHighlightingTextSelectionMenu";

interface TextSelectionMenuProps {
  editor: Editor;
}

const TextSelectionMenu = ({ editor }: TextSelectionMenuProps) => {
  const {
    activeGuidedHighlightingQuestion,
    activityPanel,
    isReadAloudModeActive,
  } = getDynamicData(editor.state);

  if (isReadAloudModeActive) return null;

  const isGuidedHighlightingModeActive =
    activityPanel === GUIDED_HIGHLIGHTING_ACTIVITY_PANEL;
  const isAttemptWithinLimit =
    (activeGuidedHighlightingQuestion?.attempt || 1) <= 2;
  const isHighlightingTextEmpty =
    !activeGuidedHighlightingQuestion?.selectedText;

  if (
    isGuidedHighlightingModeActive &&
    isAttemptWithinLimit &&
    isHighlightingTextEmpty
  ) {
    return <GuidedHighlightingTextSelectionMenu editor={editor} />;
  }

  return <AnnotationsTextSelectionMenu editor={editor} />;
};

export default TextSelectionMenu;
